import React from "react";
import { Link } from "react-router-dom";
import { clearBuilderReturn, readBuilderReturn } from "../events/builder/state/builderReturn";
import "./BuilderReturnBar.scss";

/** Shown on integration screens when the user arrived from the event builder. */
const BuilderReturnBar = () => {
  const back = readBuilderReturn();
  if (!back) return null;
  return (
    <div className="builder-return-bar">
      <Link to={back} className="builder-return-btn" onClick={clearBuilderReturn}>
        Back to event builder
      </Link>
    </div>
  );
};

export default BuilderReturnBar;
